// extracted by mini-css-extract-plugin
export default {"NoContent":"PostDetailPage_NoContent__IUA2C"};